// MA-1056 — /teacher/start?src=<tag>, the website's "Set up a free class"
// entry. main.jsx has already captured the entry (src/lib/teacher/
// pendingTeacherStart.ts) before the router ran, so this route only forwards
// to the teacher area's Class setup tab, keeping every other query parameter.
// It renders nothing and adds no sign-in of its own: App.jsx's gate ladder
// (sign-in, the private-beta gate) runs above the Outlet for the destination
// exactly as it does for /teacher, and /teacher keeps its grown-up gate.
// `teacher_` (trailing underscore) keeps this route out of /teacher's layout.
import { createFileRoute, redirect } from "@tanstack/react-router";
import { teacherStartDestination } from "@/lib/teacher/pendingTeacherStart";

export const Route = createFileRoute("/teacher_/start")({
  beforeLoad: ({ search }) => {
    throw redirect(teacherStartDestination(search as Record<string, unknown>));
  },
  component: () => null,
});
